import React from 'react';
import { Phone, Mail, MapPin, Calendar } from 'lucide-react';

const Contact = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="relative min-h-[60vh] flex items-center w-full bg-gray-900 dark:bg-black">
        
        <div className="relative z-10 px-6 lg:px-8 py-20 text-center text-white w-full max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Contact <span className="text-orange-400">Us</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 opacity-90">
            Ready to protect your equipment from rust? Get in touch for a free assessment
          </p>
          <button className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-200 hover:scale-105 flex items-center justify-center space-x-2 mx-auto">
            <Calendar className="h-5 w-5" />
            <span>Book Free Rust Check</span>
          </button>
        </div>
      </section>

      {/* Contact Content */}
      <section className="py-20 px-6 bg-white dark:bg-gray-900">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12">
            <div>
              <h2 className="text-3xl font-bold mb-6 text-gray-900 dark:text-white">
                Get in Touch
              </h2>
              <div className="space-y-4 mb-8">
                <div className="flex items-center space-x-3">
                  <Phone className="h-5 w-5 text-orange-600 dark:text-orange-400" />
                  <span className="text-gray-600 dark:text-gray-300">
                    +1 (555) RUST-PRO
                  </span>
                </div>
                <div className="flex items-center space-x-3">
                  <Mail className="h-5 w-5 text-orange-600 dark:text-orange-400" />
                  <span className="text-gray-600 dark:text-gray-300">
                    contact@rustguardpro.com
                  </span>
                </div>
                <div className="flex items-center space-x-3">
                  <MapPin className="h-5 w-5 text-orange-600 dark:text-orange-400" />
                  <span className="text-gray-600 dark:text-gray-300">
                    456 Industrial Drive, Metalworks City, MC 54321
                  </span>
                </div>
              </div>
              
              <div>
                <h3 className="text-lg font-semibold mb-3 text-gray-900 dark:text-white">
                  Service Hours
                </h3>
                <div className="space-y-1 text-gray-600 dark:text-gray-300">
                  <div>Monday - Friday: 7:00 AM - 6:00 PM</div>
                  <div>Saturday: 8:00 AM - 4:00 PM</div>
                  <div>Sunday: Emergency calls only</div>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">
                Request Free Assessment
              </h3>
              <form className="space-y-6">
                <div>
                  <label className="block text-sm font-medium mb-2 text-gray-700 dark:text-gray-300">
                    Full Name
                  </label>
                  <input
                    type="text"
                    className="w-full px-4 py-3 rounded-lg border bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:border-orange-500 dark:focus:border-orange-400 focus:outline-none focus:ring-2 focus:ring-opacity-50 transition-colors duration-200"
                    placeholder="Enter your full name"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2 text-gray-700 dark:text-gray-300">
                    Email Address
                  </label>
                  <input
                    type="email"
                    className="w-full px-4 py-3 rounded-lg border bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:border-orange-500 dark:focus:border-orange-400 focus:outline-none focus:ring-2 focus:ring-opacity-50 transition-colors duration-200"
                    placeholder="Enter your email address"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2 text-gray-700 dark:text-gray-300">
                    Service Needed
                  </label>
                  <select 
                    className="w-full px-4 py-3 rounded-lg border bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:border-orange-500 dark:focus:border-orange-400 focus:outline-none focus:ring-2 focus:ring-opacity-50 transition-colors duration-200"
                    aria-label="Select a service"
                  >
                    <option>Select a service</option>
                    <option>Mobile Rust Removal</option>
                    <option>Protective Anti-Rust Coatings</option>
                    <option>Preventative Maintenance Plans</option>
                    <option>Industrial Equipment Restoration</option>
                    <option>Surface Sealing & Barriers</option>
                    <option>Emergency Rust Response</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2 text-gray-700 dark:text-gray-300">
                    Project Details
                  </label>
                  <textarea
                    rows={4}
                    className="w-full px-4 py-3 rounded-lg border bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:border-orange-500 dark:focus:border-orange-400 focus:outline-none focus:ring-2 focus:ring-opacity-50 transition-colors duration-200"
                    placeholder="Describe your rust protection needs"
                  ></textarea>
                </div>
                <button
                  type="button"
                  className="w-full bg-orange-600 hover:bg-orange-700 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-200 hover:scale-105"
                >
                  Request Free Assessment
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
